import React, { useCallback, useEffect, useRef, useState } from "react";
import CoclubSwiperSlide from "./coclub-swiper-slide";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import CoclubModels from "../CoclubModels";
import { mobileIs } from "../../utils/siteUtils";
import Swiper from "swiper";
import { gtag } from "../../utils";
import classNames from "classnames";

import "./style.scss";
let i=0;
let b=0;
let modelShowUpdata=false;
const CoclubSwiper = props => {
  const { lang, fields, page } = props;
  const isAR = page?.fields?.rtl?.value;
  const { title, titleMobile, pcTopNodes, pcBottomNodes, mNodes, paddingAboveBottom, paddingAboveTop, titleSize, theme } = fields; 
  const rootEl = useRef(null);
  const modelEl = useRef();
  const swiperEl = useRef(null);
  const swiperWarrperEl = useRef(null);
  const swiperElPc = useRef(null);
  const swiperElPcB = useRef(null);
  const wrapperEl = useRef(null);
  const wrapperElB = useRef(null);
  const swiper = useRef(null);
  const mSlideGroups = mNodes;
  const mSildeLength = useRef(mSlideGroups.length);
  const slideGroups = pcTopNodes;
  const slideGroupsB = pcBottomNodes;
  const sildeLength = useRef(slideGroups.length);
  const [activeSlide, setActiveSlide] = useState(null);
  const [previousIndex, setPreviousIndex] = useState(null);
  const [modelShow, setModelShow] = useState(false);
  const [modelSlideData, setModelSlideData] = useState([])
  const [isRever, setIsRever] = useState(false)
  const [moving, setMoving] = useState(false);
  const [movingB, setMovingB] = useState(false);
  const [isMoving, setIsMoving] = useState(false);
  const [isMovingB, setIsMovingB] = useState(false);
  const [showCoclub, setShowCoclub] = useState(false);
  const [swiperRight, setSwiperRight] = useState(0);
  const [swiperRightB, setSwiperRightB] = useState(0);
  const [loadedItem,setLoadedItem] = useState({});
  const timer= useRef();
  const timerB= useRef();
  const [count, setCount] = useState(0);
  const [countB, setCountB] = useState(0);
  const swiperElCon = useRef(null);
  const isMobile = mobileIs();

  const onResize = () => {
    if (window.innerWidth < 1200) {
      setSwiperRight(wrapperEl.current.getBoundingClientRect().width)
      setSwiperRightB(wrapperElB.current.getBoundingClientRect().width)
    }
    if (window.innerWidth < 992 ) {
      buildSwiper()
    }
  };
  
  const buildSwiper = () => {
    if (swiper.current) {
      return false
    }
    if(modelShow){
      if(isMobile){
        swiper.current.autoplay.stop()
      }
    }
    if(swiperEl.current){
      swiper.current = new Swiper(swiperEl.current, {
        slidesPerView: isMobile? 1: "auto",
        spaceBetween: 0,
        loop: true ,
        autoplay: false,
        autoplayDisableOnInteraction:false,
        reverseDirection: isAR ? true : false,
        on: {
          slideChangeTransitionStart() {
            if(swiper.current && isMobile){
              var  alist = document.getElementsByClassName('c-coclub-swiper')[0].getElementsByClassName( "video-js" );
              if (alist){
                for ( var  idx = 0; idx < alist.length; idx ++){
                  var  mya = alist[idx];
                  mya.classList.add("videoHide")
                  mya.classList.remove("vjs-has-started")
                }
              };
              if(swiper.current.activeIndex === 0){
                setTimeout(() => {
                  swiper.current.slideToLoop(mSildeLength.current-1, 0, true);
                }, 500);
                if(!modelShowUpdata){
                  setTimeout(v=>{
                    swiper.current.autoplay.start()
                  })
                }
              }
              if(swiper.current.activeIndex === mSildeLength.current+1){
                setTimeout(() => {
                  swiper.current.slideToLoop(0, 0, true);
                }, 500);
                if(!modelShowUpdata){
                  setTimeout(v=>{
                    swiper.current.autoplay.start()
                  })
                }
              }
              setPreviousIndex(swiper.current.previousIndex)
              setActiveSlide(swiper.current.realIndex+1);
            }
          },
          slideChangeTransitionEnd() {
            if(swiper.current && isMobile){
              var  alist = document.getElementsByClassName( "video-js" );
              if (alist){
                for ( var  idx = 0; idx < alist.length; idx ++){
                  var  mya = alist[idx];
                  mya.classList.remove("videoHide")
                }
              };
            }
          }
        }
      });
      window.aaa = swiper.current;
    }
  };
  const onSlideClick = (data, type, group) => {
    gtag('event', 'Component_info', {
      'component_name': 'CoclubSwiper',
      'page_title': page?.name
    });
		if(!group?.fields?.model) {
			return false;
		}
    if(type === 1) {
      setModelSlideData(slideGroups)
      setIsRever(false)
    } else if(type === 2) {
      setModelSlideData(slideGroupsB)
      setIsRever(true)
    } else {
      setModelSlideData(mSlideGroups)
      setIsRever(false)
    }
    
    if(isMoving || isMovingB) return false
    document.getElementsByTagName('html')[0].className = 'modal-open';
    if(isMobile){
      window.removeEventListener("scroll", handleScroll);
      swiper.current.autoplay.stop()
    }
    setActiveSlide(data+1)
    setModelShow(true)
    modelShowUpdata = true
    window.scrollBody= document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    document.body.style.position = "fixed";
    document.body.style.overflowY = "hidden";
  };
  const swiperMouseOver = () => {
    if(swiper.current && isMobile){
      swiper.current.autoplay.stop()
    }
    if(swiperElPc.current){
      setMoving(false)
    }
  };
  const swiperMouseOverB = () => {
    if(swiper.current && isMobile){
      swiper.current.autoplay.stop()
    }
    if(swiperElPcB.current){
      setMovingB(false)
    }
  };
  const swiperMouseOut = () => {
    if(swiperElPc.current){
      setMoving(true)
    }
  };
  const swiperMouseOutB = () => {
    if(swiperElPcB.current){
      setMovingB(true)
    }
  };
  
  const swiperMouseDown  = (event) => {
    var osmall = wrapperEl.current
    var e = event || window.event
    var offsetX = 0;
    /*用于保存小的div拖拽前的坐标*/
    if(swiperElPc&&swiperElPc.current){
      if(isAR){
        osmall.startX = e.clientX - osmall.offsetLeft - swiperRight +swiperElPc.current.getBoundingClientRect().width
      }else{
        osmall.startX = e.clientX - osmall.offsetLeft
      }
    }
    document.onmousemove = function (event) {
      setIsMoving(true)
        var e = event || window.event
        offsetX = osmall.startX  - e.clientX
        var domOffsetX = count-offsetX
        if(isAR){
          if((Math.abs(domOffsetX) > swiperRight/2 ) || Math.abs(domOffsetX) === swiperRight/2){
            if(i!==1){ 
              osmall.style.transform =`translateX(${domOffsetX-swiperRight/2}px)`
              i=domOffsetX-swiperRight/2
            }else{
              osmall.style.transform = `translateX(${1}px)`
              i=1
            }
          } else if(domOffsetX < 0 || domOffsetX === 0){
            if(i!==swiperRight/2){
              osmall.style.transform =`translateX(${domOffsetX+swiperRight/2}px)`
              i=domOffsetX+swiperRight/2
            }else{
              osmall.style.transform = `translateX(${swiperRight/2}px)`
              i=swiperRight/2
            }
          }else{
            osmall.style.transform = `translateX(${domOffsetX}px)`
            i = (domOffsetX)
          }
        } else {
          if((Math.abs(domOffsetX) > swiperRight/2 ) || Math.abs(domOffsetX) === swiperRight/2){
            if(i!==1){ 
              osmall.style.transform =`translateX(${domOffsetX+swiperRight/2}px)`
              i=domOffsetX+swiperRight/2
            }else{
              osmall.style.transform = `translateX(${1}px)`
              i=1
            }
          }else if(domOffsetX > 0 || domOffsetX === 0){
            if(i!==-swiperRight/2){
              osmall.style.transform =`translateX(${domOffsetX-swiperRight/2}px)`
              i=domOffsetX-swiperRight/2
            }else{
              osmall.style.transform = `translateX(-${swiperRight/2}px)`
              i=-swiperRight/2
            }
          }else{
            osmall.style.transform = `translateX(${domOffsetX}px)`
            i = (domOffsetX)
          }
        }
        setCount(i);
    };
    document.onmouseup = function () {
      setTimeout(v=>{
        setIsMoving(false)
      },100)
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }
  const swiperMouseDownB  = (event) => {
    var osmall = wrapperElB.current
    var e = event || window.event
    var offsetX = 0;
    /*用于保存小的div拖拽前的坐标*/
    if(swiperElPcB&&swiperElPcB.current){
      if(!isAR){
        osmall.startX = e.clientX - osmall.offsetLeft - swiperRightB +swiperElPcB.current.getBoundingClientRect().width
      }else{
        osmall.startX = e.clientX - osmall.offsetLeft
      }
    }
    document.onmousemove = function (event) {
      setIsMovingB(true)
        var e = event || window.event
        offsetX = osmall.startX  - e.clientX
        var domOffsetX = countB-offsetX
        if(!isAR){
          if((Math.abs(domOffsetX) > swiperRightB/2 ) || Math.abs(domOffsetX) === swiperRightB/2){
            if(b!==1){ 
              osmall.style.transform =`translateX(${domOffsetX-swiperRightB/2}px)`
              b=domOffsetX-swiperRightB/2
            }else{
              osmall.style.transform = `translateX(${1}px)`
              b=1
            }
          } else if(domOffsetX < 0 || domOffsetX === 0){
            if(b!==swiperRightB/2){
              osmall.style.transform =`translateX(${domOffsetX+swiperRightB/2}px)`
              b=domOffsetX+swiperRightB/2
            }else{
              osmall.style.transform = `translateX(${swiperRightB/2}px)`
              b=swiperRightB/2
            }
          }else{
            osmall.style.transform = `translateX(${domOffsetX}px)`
            b = (domOffsetX)
          }
        } else {
          if((Math.abs(domOffsetX) > swiperRightB/2 ) || Math.abs(domOffsetX) === swiperRightB/2){
            if(b!==1){ 
              osmall.style.transform =`translateX(${domOffsetX+swiperRightB/2}px)`
              b=domOffsetX+swiperRightB/2
            }else{
              osmall.style.transform = `translateX(${1}px)`
              b=1
            }
          }else if(domOffsetX > 0 || domOffsetX === 0){
            if(b!==-swiperRightB/2){
              osmall.style.transform =`translateX(${domOffsetX-swiperRightB/2}px)`
              b=domOffsetX-swiperRightB/2
            }else{
              osmall.style.transform = `translateX(-${swiperRightB/2}px)`
              b=-swiperRightB/2
            }
          }else{
            osmall.style.transform = `translateX(${domOffsetX}px)`
            b = (domOffsetX)
          }
        }
        setCountB(b);
    };
    document.onmouseup = function () {
      setTimeout(v=>{
        setIsMovingB(false)
      },100)
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }
  const swiperMouseUp = (e) => {
    if(isMoving){
      setTimeout(v=>{
        setIsMoving(false)
      },100)
    }
  }
  const swiperMouseUpB = (e) => {
    if(isMovingB){
      setTimeout(v=>{
        setIsMovingB(false)
      },100)
    }
  }
  const handleScroll = useCallback(() => {
    let elem = rootEl.current;
    if (elem === undefined) {
      return;
    }
      let rect = elem.getBoundingClientRect();
      let winHeight = window.innerHeight || document.documentElement.clientHeight;
      if(rect.top < (winHeight/2)){
        if(swiper.current && !modelShow && isMobile){
          swiper.current.autoplay.start()
        }
        if( !moving && swiperElPc && swiperElPc.current && !modelShow && !isMobile && Object.keys(loadedItem).length === sildeLength.current){
         setTimeout(v=>{
          setMoving(true)
          setMovingB(true)
         },10)
        }
      }
  }, [])

  const nextItem = () => {
    if(isMobile){
      swiper.current.autoplay.stop()
    }
    modelEl.current.scrollTop = 0;
    let index = activeSlide
    if( index === mSildeLength.current ){
        index = 1
    }else{
        index ++
    }
    swiper.current.slideNext()
    setActiveSlide(index);
  };
  const prevItem = () => {
      if(isMobile){
        swiper.current.autoplay.stop()
      }
      modelEl.current.scrollTop = 0;
      let index = activeSlide
      if( index === 1 ){
          index = mSildeLength.current
      }else{
          index --
      }
      swiper.current.slidePrev()
      setActiveSlide(index);
  };
  const close = () => {
    if(isMobile){
      swiper.current.autoplay.start()
    }
    window.addEventListener("scroll", handleScroll);
    document.body.style.position = "relative";
    document.body.style.overflowY = "auto";
    window.scrollTo(window.scrollBody,window.scrollBody); 
    setModelShow(false)
    modelShowUpdata = false
  }
  useEffect(() => {
    setTimeout(v=>{
      if(isMobile) {
        buildSwiper();
      }
    },100)
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", onResize);
    return () => {
      if (swiper.current) {
        swiper.current.destroy(true, true);
      }
      document.body.style.position = "relative";
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", onResize);
      clearInterval(timer.current);
      clearInterval(timerB.current);
    };
  }, []);
  
  useEffect(() => {
    if(moving){
      coclubTime()
    }
    if(!moving && timer.current!=null){
      clearInterval(timer.current)
      timer.current = null
    }
  }, [moving]);
  useEffect(() => {
    if(movingB){
      coclubTimeB()
    }
    if(!movingB && timerB.current!=null){
      clearInterval(timerB.current)
      timerB.current = null
    }
  }, [movingB]);
  const coclubTime = () => {
    timer.current = setInterval(() => {
      if(!isAR){
        i=i-1;
        if( Math.abs(i) > swiperRight/2 || Math.abs(i) === swiperRight/2){
          i = 1
        }
      }else{
        i=i+1;
        if( i > swiperRight/2 || i === swiperRight/2){
          i = 1
        }
      }
      setCount(i);
    }, 60);

  }
  const coclubTimeB = () => {
    timerB.current = setInterval(() => {
      if(isAR){
        b=b-1;
        if( Math.abs(b) > swiperRightB/2 || Math.abs(b) === swiperRightB/2){
          b = 1
        }
      }else{
        b=b+1;
        if( b > swiperRightB/2 || b === swiperRightB/2){
          b = 1
        }
      }
      setCountB(b);
    }, 60);
  } 
  const handleLoad = (id)=>{
    let newData = loadedItem;
    if( newData[id] ){ return false }
    newData[id] = id;
    setLoadedItem(newData);
    if( Object.keys(loadedItem).length === sildeLength.current && !modelShow){
      setShowCoclub(true)
      if(!isMobile){handleScroll()}
      setSwiperRight(wrapperEl.current.getBoundingClientRect().width)
      setSwiperRightB(wrapperElB.current.getBoundingClientRect().width)
    }
  }
  useEffect(() => {
    if(!modelShow){
      window.addEventListener("scroll", handleScroll)
    }else{
      window.removeEventListener("scroll", handleScroll)
    }
  }, [modelShow]);   
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);   
  
  let top = paddingAboveTop ? paddingAboveTop?.fields?.phrase?.value : "none",
  bottom = paddingAboveBottom ? paddingAboveBottom?.fields?.phrase?.value : "none",
  size = titleSize ? titleSize?.fields?.phrase?.value : "default";
  const coclubClasses = classNames("padding-top-" + top, "padding-bottom-" + bottom, "theme-" + theme?.fields?.phrase?.value);
  return (
    <>
    <div className={classNames("c-coclub-swiper",coclubClasses)}   ref={rootEl}>
      <div className={classNames("c-coclub-swiper-title",size)} >
        <RichText tag="div" field={isMobile ? titleMobile : title} />
      </div>
      <div className={classNames("c-coclub-swiper-content pcs",{'show':showCoclub})} ref={swiperElPc} 
      onMouseUp={swiperMouseUp} onMouseDown={swiperMouseDown} onMouseOver={swiperMouseOver} onMouseLeave={swiperMouseOut} >
        <div className="swiper-wrapper">
          <div className="swiper-wrapper-con" ref={wrapperEl} style={{transform:[`translateX(${count}px)`]}}>
            {slideGroups.map((group, i) => (
              <div className="swiper-slide" key={i} onClick={()=>onSlideClick(i, 1, group)}>
                <CoclubSwiperSlide index={i} slides={group} itemLoader={handleLoad}/>
              </div>
            ))}
            {slideGroups.map((group, i) => (
              <div className="swiper-slide" key={i+ 100} onClick={()=>onSlideClick(i, 1, group)}>
                <CoclubSwiperSlide index={i+slideGroups.length} slides={group} itemLoader={handleLoad}/>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classNames("c-coclub-swiper-content pcs bottom",{'show':showCoclub})} ref={swiperElPcB} 
      onMouseUp={swiperMouseUpB} onMouseDown={swiperMouseDownB} onMouseOver={swiperMouseOverB} onMouseLeave={swiperMouseOutB} >
        <div className="swiper-wrapper">
          <div className="swiper-wrapper-con" ref={wrapperElB} style={{transform:[`translateX(${countB}px)`]}}>
            {slideGroupsB.map((group, i) => (
              <div className="swiper-slide" key={i} onClick={()=>onSlideClick(i, 2, group)}>
                <CoclubSwiperSlide index={i} slides={group} itemLoader={handleLoad}/>
              </div>
            ))}
            {slideGroupsB.map((group, i) => (
              <div className="swiper-slide" key={i + 200} onClick={()=>onSlideClick(i, 2, group)}>
                <CoclubSwiperSlide index={i+slideGroupsB.length} slides={group} itemLoader={handleLoad}/>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="c-coclub-swiper-content swiper-container phs" ref={swiperEl} >
        <div className="swiper-wrapper" ref={swiperWarrperEl}>
          {mSlideGroups.map((group, i) => (
            <div className="swiper-slide" key={i}>
              <CoclubSwiperSlide modelShow={modelShow} length={mSlideGroups.length} previousIndex={previousIndex} activeSlide={activeSlide} index={i} slides={group} videoPlay={swiperMouseOver} onClick={v=>onSlideClick(i, 3, group)}/>
            </div>
          ))}
        </div>
        <div className="swiper-pagination-content">{activeSlide||1} &nbsp;—&nbsp; {mSildeLength.current}</div>
      </div>
      { modelShow &&
        <div className="swiper-models">
          <div className="models-content" ref={modelEl}>
            {modelSlideData.map((group, i) => (
              <>
              {
                i === activeSlide-1 &&
                <div className={classNames("detail",{show: i === activeSlide-1})} key={i}>
                  <CoclubModels isAR={(isAR || isRever)} swiperData={group} index={i} next={nextItem} activeSlide={activeSlide} prev={prevItem} close={close}/>
                  {/* amber */}
                </div>
              }
              </>
            ))}
          </div>
        </div>
      }
    </div>
    </>
  );
};
export default CoclubSwiper;
